import * as THREE from 'three'
require('three-orbitcontrols');

import Toast from 'vux/src/components/toast/index.vue'


import printModel from '../../../3dapps/mixins/printModel'

import { initThree, camera, renderer, currentMesh, updateBox } from './initThree'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Popup from 'vux/src/components/popup/index.vue'


import loading from '@/components/loading';

import img000 from '../imgs/无.png';
import img001 from '../imgs/1.png';
import img002 from '../imgs/2.png';
import img003 from '../imgs/3.png';
import img004 from '../imgs/4.png';

export default {
name: "box",
mixins: [printModel],
components: {
Group,
XDialog,
Actionsheet,
Grid, GridItem, XNumber, XInput, Popup, Radio, Flexbox, FlexboxItem, Toast, loading
},

data() {
return {
quotationName: "3D收纳盒",
productType: "收纳盒",
landscape: true,//竖屏状态要一直为true
showSize: false,
showPrint: false,
index: [],
boxData: {
size: {
w: 60, // 长
h: 60, // 宽
d: 60, // 高
t: 1, // 壁厚
},
closeTop: false, // 上方加盖
edge: 4,
cubicle: 1,
},
showEdges: false,
edgeOld: 4,
edgeList: [{
key: 4,
value: "四边形"
}, {
key: 5,
value: "五边形"
}, {
key: 6,
value: "六边形"
}, {
key: 8,
value: "八边形"
}, {
key: 12,
value: "十二边形"
}, {
key: 100,
value: "圆"
}],
addCartIndex: -1,
orderIndex: -1,
isreliefBtnIndex: -1,//顶部按钮默认
showCubicles: false,
cubicleOld: 0,

cubicleList: [img000, img001, img002, img003, img004],
showCircleBtn: true,
showImg: true,
showLoading: false,
btnsList: [//按钮列表
{
isClick: false,
icon: require("../../../3dapps/imgs/尺寸.png"),
iconClick: require("../../../3dapps/imgs/尺寸-选中.png"),
title: "尺寸",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/边数.png"),
iconClick: require("../../../3dapps/imgs/边数-选中.png"),
title: "边数",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/间隔.png"),
iconClick: require("../../../3dapps/imgs/间隔-选中.png"),
title: "间隔",
},
],
sizeList: [{
title: "长度",
num: 60,
placeholder: "长度不能超过300MM",
}, {
title: "宽度",
num: 60,
placeholder: "宽度不能超过200MM",
}, {
title: "高度",
num: 60,
placeholder: "高度不能超过200MM",
}, {
title: "厚度",
num: 1,
placeholder: "厚度不能超过9MM",
}],
}
},
mounted() {
const scope = this;
scope.showLoading = true;

var mo = function (e) {
e.preventDefault();
}


initThree(scope.$refs.canvas);


scope.$nextTick(function () {
scope.$refs.box.style.paddingTop = '0px';
scope.$refs.box.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);
});


const contentDOM = scope.$refs.box;

const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}
scope.init3d(contentDOM, camera, renderer, resize1);

updateBox(this.boxData);

setTimeout(() => {
scope.showLoading = false;
scope.init3d(contentDOM, camera, renderer, resize1);
}, 50);

this.$nextTick(function () {
scope.loadData();

});
},
methods: {

handler(index) {
if (index === 0) {//尺寸
this.isreliefBtnIndex = index;
this.showSize = true;

this.showEdges = false;
this.showCubicles = false;
this.btnsList[0].isClick = true;
this.btnsList[2].isClick = false;
this.btnsList[1].isClick = false;

this.updatedData();



return;
} else if (index === 1) {//边数
this.isreliefBtnIndex = index;
this.showEdges = !this.showEdges;
this.showSize = false;
this.showCubicles = false;
this.btnsList[1].isClick = true;
this.btnsList[0].isClick = false;
this.btnsList[2].isClick = false;

if (!this.showEdges) {
this.isTopBtn();
}
return;
} else if (index === 2) {//间隔
this.isreliefBtnIndex = index;
this.showCubicles = !this.showCubicles;
this.showEdges = false;
this.showSize = false;
this.btnsList[2].isClick = true;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;

if (!this.showCubicles) {
this.isTopBtn();
}
return;
}
},

loadData() {
const scope = this;
if (window.localStorage) {
let dataStr = localStorage.getItem("box");
localStorage.removeItem("box"); 
if (dataStr) {
let data = JSON.parse(dataStr);
scope.boxData.size.w = data.w;
scope.boxData.size.h = data.h;
scope.boxData.size.d = data.d;
scope.boxData.size.t = data.t;
scope.boxData.closeTop = data.closeTop;
scope.boxData.cubicle = data.cubicle;
scope.boxData.edge = data.edge;
scope.fontsItemIndex = data.fontsItemIndex;


scope.showLoading = true;

setTimeout(function () {
scope.showLoading = false;
}, 50);
}
}
},


saveData() {
if (window.localStorage) {
let data = {};
data.w = this.boxData.size.w;
data.h = this.boxData.size.h;
data.d = this.boxData.size.d;
data.t = this.boxData.size.t;
data.closeTop = this.boxData.closeTop;
data.cubicle = this.boxData.cubicle;
data.edge = this.boxData.edge;
data.fontsItemIndex = this.fontsItemIndex;

localStorage.setItem("box", JSON.stringify(data));
}
},

isTopBtn() {
this.isreliefBtnIndex = -1;
this.showCubicles = false;
this.showEdges = false;
this.showSize = false;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.btnsList[2].isClick = false;
},


selectFuimg() {
this.showImg = !this.showImg;
this.boxData.closeTop = !this.boxData.closeTop;
},


updatedData() {

if (this.boxData.size.w == "" && this.boxData.size.h == "" && this.boxData.size.d == "" && this.boxData.size.t == ""
|| this.boxData.size.w == "" || this.boxData.size.h == "" || this.boxData.size.d == "" || this.boxData.size.t == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.showLoading = false;
this.showSize = true;
} else if (this.boxData.size.w < 60) {
this.$vux.toast.show({
text: '最小长度为60毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (this.boxData.size.w > 300) {
this.$vux.toast.show({
text: '最大长度为300毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (this.boxData.size.h < 60) {
this.$vux.toast.show({
text: '最小宽度为60毫米',
type: "warn",
time: 2000,
position: "middle",
})
this.showSize = true;
this.showLoading = false;
return;
} else if (this.boxData.size.h > 200) {
this.$vux.toast.show({
text: '最大宽度为200毫米',
type: "warn",
time: 2000,
position: "middle",
})
this.showSize = true;
this.showLoading = false;
return;
} else if (this.boxData.size.d < 60) {
this.$vux.toast.show({
text: '最小高度为60毫米',
type: "warn",
time: 2000,
position: "middle",
})
this.showSize = true;
this.showLoading = false;
return;
} else if (this.boxData.size.d > 200) {
this.$vux.toast.show({
text: '最大高度为200毫米',
type: "warn",
time: 2000,
position: "middle",
})
this.showSize = true;
this.showLoading = false;
return;
} else if (this.boxData.size.t < 1) {
this.$vux.toast.show({
text: '最小壁厚为1毫米',
type: "warn",
time: 2000,
position: "middle",
})
this.showSize = true;
this.showLoading = false;
return;
} else if (this.boxData.size.t > 9) {
this.$vux.toast.show({
text: '最大壁厚为9毫米',
type: "warn",
time: 2000,
position: "middle",
})
this.showSize = true;
this.showLoading = false;
return;
}
setTimeout(() => {
this.showLoading = false;
updateBox(this.boxData);
}, 50);
},


isNoData() {
if (this.boxData.size.w == "" && this.boxData.size.h == "" && this.boxData.size.d == "" && this.boxData.size.t == ""
|| this.boxData.size.w == "" || this.boxData.size.h == "" || this.boxData.size.d == "" || this.boxData.size.t == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.showLoading = false;
this.showCubicles = false;
this.showEdges = false;
this.showSize = true;
} else if (this.boxData.text == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.boxData.text = "齐思印";
this.showText = true;
this.showCubicles = false;
this.showEdges = false;
this.showSize = false;
this.showLoading = false;
}
},


cancelPop() {
this.isTopBtn();
this.showCircleBtn = true;
this.updatedData();
},


isSure() {
this.isTopBtn();
this.showLoading = true;
this.showCircleBtn = true;
this.updatedData();
},


touchstart() {
this.isTopBtn();
this.updatedData();
},


setEdgesCancel() {
this.boxData.edge = this.edgeOld;
this.isTopBtn();
},


setEdgesDone() {
updateBox(this.boxData);
this.isTopBtn();
},


setCubiclesCancel() {

this.isTopBtn();
console.log("间隔取消", this.boxData.cubicle);
},


setCubiclesItemClick(index) {
this.isTopBtn();
this.boxData.cubicle = index;
updateBox(this.boxData);
console.log("间隔子项", this.boxData.cubicle);
},

makeStlBlob() {
let exporter = new THREE.STLExporter();
let group = currentMesh;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
},


print() {
this.showLoading = true;
this.isTopBtn();
this.isNoData();



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showlowpriceHeight = true;

}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showlowpriceHeight = false;

}

if(currentMesh){
this.saveData();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
const scope = this;
this.getPrice().then(() => {
scope.showLoading = false;
});
});
}
else {
this.$vux.toast.show({
text: '收纳盒不能为空',
type: "warn",
time: 2000,
position: "middle",
});
this.updateMesh();
}












































},


getModelToPrint() {
let group = currentMesh;
return group;
}

},
watch: {
"boxData.closeTop": function () {
updateBox(this.boxData);
},
},
}


// WEBPACK FOOTER //
// ./src/views/box3d/scripts/index.js